// import InfoIcon from '@/assets/images/common/svg/info.svg?react';
import AddIcon from '@/assets/images/common/svg/plus.svg?react';
import { AddMembersFrom } from '@/contexts/chatModal/useChatModal/types';
import { useChatModalContext } from '@/contexts/chatModal/context';
import { useChatContext } from '@/contexts/chat/context';
import { useSessionContext } from '@/contexts/session/context';
import styles from './index.module.scss';
import type { GroupCreateCardProps } from './type';

export const GroupCreateCard = ({ chat }: GroupCreateCardProps) => {
  const { chatModal } = useChatModalContext();
  const { session } = useSessionContext();
  const {
    chatGroup: {
      chatGroupState: {
        state: { membersMap, groupMap },
      },
    },
  } = useChatContext();

  const normalMemberList = useMemo(
    () => membersMap[chat?.chat_id ?? '']?.normalMembers,
    [membersMap, chat?.chat_id]
  );

  const inGroup = useMemo(() => {
    return normalMemberList?.some((member) => member.user_id === session.user?.userId);
  }, [normalMemberList, session.user?.userId]);

  const group = useMemo(() => groupMap[chat?.chat_id ?? ''], [groupMap, chat?.chat_id]);

  const titleText = useMemo(() => {
    if (group?.creator_uid === session.user?.userId) {
      return <span>You created this group</span>;
    }
    const creator = membersMap[group?.group_id ?? '']?.members.find(
      (member) => member.user_id === group?.creator_uid
    );
    return <span>{creator?.name} invited you</span>;
  }, [group?.creator_uid, group?.group_id, session.user?.userId, membersMap]);

  return (
    <div className={styles.groupCreateCard}>
      <MyAvatar
        size="extraLarge"
        category={chat.category}
        src={chat?.avatar}
        info={chat?.user}
      ></MyAvatar>
      <div className={styles.title}>{titleText}</div>
      <div className={styles.members}>Group · {normalMemberList?.length} members</div>
      {/* <div className={styles.addDescBtn} onClick={onClickDesc}>
        Add description...
      </div> */}
      <div className={styles.operation}>
        {/* <div
          className={styles.operationBtn}
          onClick={() => {
            chatModal.setOpenGroupSetting(true);
          }}
        >
          <div className={styles.operationIcon}>
            <InfoIcon />
          </div>
          <div className={styles.operationText}>Group Info</div>
        </div> */}
        {inGroup && (
          <div
            className={styles.operationBtn}
            onClick={() => {
              chatModal.setOpenAddMembers({
                open: true,
                addFrom: AddMembersFrom.GROUP_CREATE_CARD,
              });
            }}
          >
            <div className={styles.operationIcon}>
              <AddIcon />
            </div>
            <div className={styles.operationText}>Invite Members</div>
          </div>
        )}
      </div>
    </div>
  );
};
